export const CANONICAL_DASHBOARD_ROUTES = [
  '/',
  '/admin',
  '/admin/integrations',
  '/ops',
  '/customers-hub',
  '/field/crew-data-quality',
  '/fleet',
  '/growth',
  '/hiring',
  '/hiring/analytics',
  '/hiring/jobs',
  '/marketing',
  '/marketing/campaigns',
  '/marketing/hangers',
  '/marketing/leads',
  '/marketing/neighborhoods',
  '/marketing/outbound',
  '/marketing/overview',
  '/marketing/performance',
  '/marketing/route-mail',
  '/marketing/sequences',
  '/money',
] as const;
